"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MESSAGE_SIZE = 2147483.647; // 2GB
exports.KB_TO_B = 1024;
//# sourceMappingURL=ClauseValueType.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/store/schema/ClauseValueType.js
// module id = 3748
// module chunks = 2